var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37836e-06 89.9998V295C-0.00131202 299.765 0.936016 304.485 2.75855 308.888C4.58108 313.291 7.25316 317.293 10.6221 320.664C13.991 324.034 17.9907 326.708 22.3931 328.533C26.7955 330.358 31.5144 331.298 36.28 331.3H228.79C233.557 331.301 238.278 330.363 242.683 328.539C247.088 326.715 251.09 324.042 254.461 320.671C257.832 317.3 260.506 313.297 262.329 308.893C264.153 304.488 265.091 299.767 265.09 295V36.3097C265.091 31.5423 264.153 26.8215 262.329 22.4167C260.506 18.012 257.832 14.0098 254.461 10.6388C251.09 7.26777 247.088 4.59405 242.683 2.77027C238.278 0.946485 233.557 0.00845314 228.79 0.009767H90.01L18.8398 71.1597L1.37836e-06 89.9998Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9998L18.8398 71.1597L90.01 0.009767H228.79C233.557 0.00845314 238.278 0.946485 242.683 2.77027C247.088 4.59405 251.09 7.26777 254.461 10.6388C257.832 14.0098 260.506 18.012 262.329 22.4167C264.153 26.8215 265.091 31.5423 265.09 36.3097V120.67H0V89.9998Z",
    fill: "#E57E25"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.0002L44.4299 99.8102C53.8584 101.757 63.6739 99.8783 71.7173 94.5879C79.7607 89.2975 85.3731 81.0286 87.3198 71.6002L89.1799 61.4102C88.5906 64.2176 87.6568 66.9415 86.3999 69.5201C83.4288 75.6587 78.7883 80.8359 73.01 84.4581C67.2318 88.0804 60.5497 90.0012 53.73 90.0002H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90H53.6899C60.5097 90.0009 67.1917 88.0801 72.97 84.4579C78.7482 80.8356 83.3888 75.6584 86.3599 69.5199C88.7303 64.579 89.9639 59.17 89.97 53.6899V0L18.8 71.1599L0 90Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 277.47H81.9688V176.32H183.119V277.47ZM88.1187 271.36H177.039V182.44H88.0886L88.1187 271.36Z",
    fill: "#E57E25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9084 167.5H73.1484V191.26H96.9084V167.5Z",
    fill: "#E57E25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.56 197.95H66.5V160.85H103.56V197.95ZM79.8 184.65H90.26V174.15H79.8V184.65Z",
    fill: "#E57E25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9084 262.53H73.1484V286.29H96.9084V262.53Z",
    fill: "#E57E25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.56 292.95H66.5V255.88H103.56V292.95ZM79.8 279.64H90.26V269.18H79.8V279.64Z",
    fill: "#E57E25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.94 167.5H168.18V191.26H191.94V167.5Z",
    fill: "#E57E25"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M198.591 197.95H161.531V160.85H198.591V197.95ZM174.831 184.65H185.291V174.15H174.831V184.65Z",
    fill: "#E57E25"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M191.94 262.53H168.18V286.29H191.94V262.53Z",
    fill: "#E57E25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.591 292.95H161.531V255.88H198.591V292.95ZM174.831 279.64H185.291V269.18H174.831V279.64Z",
    fill: "#E57E25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.6bdd3153085db6cce64b3d954501a65a.svg";
export { ForwardRef as ReactComponent };